module.exports = __webpack_public_path__ + "img/ts2.a78c81b1.png";